interface OffsetFormula {
  attributes?: Record<string, unknown>
}

export const offsetTons = (formula?: OffsetFormula, locale = 'fr-FR'): string => {
  const tons = Number(formula?.attributes?.tons ?? 0)

  return tons > 0 ? tons.toLocaleString(locale) : ''
}
